import * as React from 'react';
import { mergeRefs } from '../hooks/useMergedRefs.js';
export const cloneElementWithRef = (children, getProps) => {
  if (!children) return null;
  if (!React.isValidElement(children)) return children;
  let props = getProps(children);
  let ref = mergeRefs(
    ...[
      'ref' in children ? children.ref : null,
      'ref' in props ? props.ref : null,
    ].filter(Boolean),
  );
  return React.cloneElement(children, {
    ...props,
    ref,
  });
};
